import React from 'react';
import './Spinner.scss';

const Spinner = () => <div className="page-spinner" />;

export default Spinner;
